
import { calculateContrastRatio } from '@/utils/colorUtils';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';

export interface ContrastCheckerProps {
  background: string;
  foreground: string;
}

const ContrastChecker = ({ background, foreground }: ContrastCheckerProps) => {
  const ratio = calculateContrastRatio(background, foreground);
  const isAALarge = ratio >= 3;
  const isAA = ratio >= 4.5;
  const isAAA = ratio >= 7;

  return (
    <div className="space-y-2">
      <h3 className="text-sm font-medium">Contrast Check</h3>
      <div className="p-4 rounded-md" style={{ backgroundColor: background }}>
        <p className="font-medium" style={{ color: foreground }}>
          Sample Text
        </p>
      </div>
      
      <div className="flex justify-between items-center text-sm mt-2">
        <span>Contrast Ratio: {ratio.toFixed(2)}:1</span>
      </div>
      
      {ratio < 4.5 && (
        <Alert variant="info" className="mt-2">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Low Contrast</AlertTitle>
          <AlertDescription>
            This color combination doesn't meet WCAG AA standards. Consider choosing colors with higher contrast.
          </AlertDescription>
        </Alert>
      )}
      
      <div className="flex flex-wrap gap-2 mt-2">
        <span className={`px-2 py-1 rounded text-xs ${isAA ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
          {isAA ? '✓' : '✗'} AA Text
        </span>
        <span className={`px-2 py-1 rounded text-xs ${isAALarge ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
          {isAALarge ? '✓' : '✗'} AA Large
        </span>
        <span className={`px-2 py-1 rounded text-xs ${isAAA ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
          {isAAA ? '✓' : '✗'} AAA
        </span>
      </div>
    </div>
  );
};

export default ContrastChecker;
